import { createStore} from "redux";
import reducers from './Reducers'

export default function store(state = {}){
  return createStore(reducers, state);
}